export default __webpack_public_path__ + "static/media/i087hp.c914a544.webp";